import {sendRequest} from "./Sender";

export const DepartmentService = {
    getGroups,
    getAdditionals,
    get,
    update,
    updateAdditional,
    addAdditional,
    deleteAdditional,
    addGroup,
    updateGroup,
    deleteGroup
}

function getGroups(params){
    return sendRequest('groups', 'GET', {...params}, true)
}


function get(id, expand = false){
    return sendRequest('departments/'+ id, 'GET', {
        'expand': expand
    }, true)
}

function update(departmentId, data){
    return sendRequest('departments/' + departmentId, 'PUT', {...data}, true)
}

function addAdditional(data){
    return sendRequest('additionals', 'POST', {...data}, true)
}

function updateAdditional(data){
    return sendRequest('additionals/' + data.id, 'PUT', {...data}, true)
}

function addGroup(data){
    return sendRequest('groups', 'POST', {...data}, true)
}

function updateGroup(data){
    return sendRequest('groups/' + data.id, 'PUT', {...data}, true)
}

function deleteGroup(id){
    return sendRequest('groups/' + id, 'DELETE', {}, true)
}


function deleteAdditional(id){
    return sendRequest('additionals/' + id, 'DELETE', {}, true)
}

function getAdditionals(params){
    return sendRequest('additionals', 'GET', {...params}, true)
}